import { render, staticRenderFns } from "./editActivitiesView.vue?vue&type=template&id=5a7ac8d4&scoped=true"
import script from "./editActivitiesView.vue?vue&type=script&lang=js"
export * from "./editActivitiesView.vue?vue&type=script&lang=js"
import style0 from "./editActivitiesView.vue?vue&type=style&index=0&id=5a7ac8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ac8d4",
  null
  
)

export default component.exports